

angular.module('admin.services').service('UserManager', function () {

    this.getCurrent = function () {
        return new Promise((resolve, reject) => {
            // busca usuário que tenha sido gravado durante a sessão.        
            var user = localStorage.getItem('ce-admin-user');
            if (user) {
                user = JSON.parse(user);                
                resolve(user);
                return;
            }
            reject();
        });
    };
    this.setCurrent = function (user, _remember) {
        const supervisorData = JSON.stringify(user.data.supervisor);
        localStorage.setItem('ce-admin-user', supervisorData);
        localStorage.setItem('ce-admin-access-token', user.data.accessToken);
        localStorage.setItem('ce-admin-refresh-token', user.data.refreshToken);
        localStorage.setItem('ce-admin-id-token', user.data.idToken);
    };
	this.setTokens = function (idToken, accessToken){
        localStorage.setItem('ce-admin-id-token', idToken);
        localStorage.setItem('ce-admin-access-token', accessToken);
	};
    this.abandon = function () {
        localStorage.clear();
        this.permissionsSet = false;        
    };
})